/**
 * <locale-modal> — full-screen region/language picker.
 * Trigger: any element with [data-locale-trigger]. Close: [data-locale-close],
 * ESC key, or click on backdrop. Body scroll locked while open.
 */
class LocaleModal extends HTMLElement {
  connectedCallback() {
    this.triggers = document.querySelectorAll('[data-locale-trigger]');
    this.closeBtn = this.querySelector('[data-locale-close]');

    this.triggers.forEach((t) => t.addEventListener('click', () => this.open()));
    if (this.closeBtn) this.closeBtn.addEventListener('click', () => this.close());

    this.addEventListener('click', (e) => {
      if (e.target === this) this.close();
    });

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && this.hasAttribute('open')) this.close();
    });
  }

  open() {
    this.setAttribute('open', '');
    this.setAttribute('aria-hidden', 'false');
    this._lastFocus = document.activeElement;
    window.theme.lockScroll('locale');
    const firstTile = this.querySelector('.locale-modal__tile');
    if (firstTile) firstTile.focus();
  }

  close() {
    this.removeAttribute('open');
    this.setAttribute('aria-hidden', 'true');
    window.theme.unlockScroll('locale');
    if (this._lastFocus && this._lastFocus.focus) this._lastFocus.focus();
  }
}

if (!customElements.get('locale-modal')) {
  customElements.define('locale-modal', LocaleModal);
}
